var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23805 4.5C6.23805 4.89782 6.07375 5.27936 5.7813 5.56066C5.48884 5.84196 5.09219 6 4.67859 6C4.265 6 3.86835 5.84196 3.57589 5.56066C3.28344 5.27936 3.11914 4.89782 3.11914 4.5C3.11914 4.10218 3.28344 3.72064 3.57589 3.43934C3.86835 3.15804 4.265 3 4.67859 3C5.09219 3 5.48884 3.15804 5.7813 3.43934C6.07375 3.72064 6.23805 4.10218 6.23805 4.5ZM5.19841 4.5C5.19841 4.36739 5.14365 4.24021 5.04616 4.14645C4.94868 4.05268 4.81646 4 4.67859 4C4.54073 4 4.40851 4.05268 4.31103 4.14645C4.21354 4.24021 4.15878 4.36739 4.15878 4.5C4.15878 4.63261 4.21354 4.75979 4.31103 4.85355C4.40851 4.94732 4.54073 5 4.67859 5C4.81646 5 4.94868 4.94732 5.04616 4.85355C5.14365 4.75979 5.19841 4.63261 5.19841 4.5Z",
    fill: "#A1A4AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07919 1H6.84696C7.12266 1.00006 7.38706 1.10545 7.58198 1.293L14.8594 8.293C15.0543 8.48053 15.1638 8.73484 15.1638 9C15.1638 9.26517 15.0543 9.51947 14.8594 9.707L10.0917 14.293C9.8967 14.4805 9.63231 14.5858 9.35664 14.5858C9.08097 14.5858 8.81658 14.4805 8.62162 14.293L1.34416 7.293C1.14918 7.10551 1.03961 6.8512 1.03955 6.586V2C1.03955 1.73478 1.14908 1.48043 1.34405 1.29289C1.53902 1.10536 1.80346 1 2.07919 1ZM2.07919 6.586L9.35664 13.586L14.1244 9L6.84696 2H2.07919V6.586Z",
    fill: "#A1A4AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.97b6e2393751e4c0924454f42da4c53e.svg";
export { ForwardRef as ReactComponent };